<ion-row class="machine-attribute-details-container">
  <ion-grid>
    <div class="machine-action-flex" *ngIf="!isCloneMode">
      <ion-button class="add-machine-btn" *ngIf="!isEditAttributes"
        shape="round" fill="outline" color="primary" (click)="onEdit()">
        {{'Edit'|translate}}
      </ion-button>
      <ng-container *ngIf="isEditAttributes">
        <ion-button class="add-machine-btn margin-right-16"
          shape="round" fill="outline" color="primary" (click)="onCancel()">
          {{'Cancel'|translate}}
        </ion-button>
        <ion-button class="add-machine-btn" [disabled]="isSaveDisabled"
          shape="round" fill="outline" color="primary" type="submit" (click)="onSave()">
          {{'Save'|translate}}
        </ion-button>
      </ng-container>
    </div>
    <form class="machine-form-scroll scrollVertical form-height" #formEle #machineForm="ngForm" ngNativeValidate
      autocomplete="off" *ngIf="isEditAttributes">
      <ion-grid class="inp-container" *ngIf="formData">
        <ion-row>
          <ion-col size="6">
            <div class="machine-each-div">
              <ion-label> {{ 'Machine Type' | translate}} *</ion-label>
              <ng-select class="cust-name-select" required [clearable]="true" bindLabel="machineType" bindValue="id"
                [(ngModel)]="formData.machineType" [items]="machineTypeList"
                (scrollToEnd)="fetchMoreMachineType" [virtualScroll]='true' #machineType="ngModel"
                name="machineType" [attr.data-field]="'machineType'"
                placeholder="{{ 'Select Machine Type' | translate}}" (ngModelChange)="onFormChange()">
              </ng-select>
              <ion-text class="validate-error"
                *ngIf="!formData.machineType">
                {{ 'required' | translate }}
              </ion-text>
            </div>
          </ion-col>
          <ion-col size="6">
            <div class="machine-each-div">
              <ion-label> {{ 'Application' | translate}} *</ion-label>
              <ng-select class="cust-name-select" required [clearable]="true" bindLabel="application" bindValue="id"
                [(ngModel)]="formData.application" [items]="applicationList"
                (scrollToEnd)="fetchMoreApplication()" [virtualScroll]='true' #application="ngModel"
                name="application" [attr.data-field]="'application'"
                placeholder="{{ 'Select Application' | translate}}" (ngModelChange)="onFormChange()">
              </ng-select>
              <ion-text class="validate-error" *ngIf="!formData.application">
                {{ 'required' | translate }}
              </ion-text>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="6">
            <div class="machine-each-div">
              <ion-label> {{ 'Control System' | translate}} *</ion-label>
              <ng-select class="cust-name-select" [multiple]="true" [selectableGroup]="true" [clearable]="true"
                bindLabel="controlSystem" bindValue="id" required [(ngModel)]="formData.controlSystem"
                [items]="controlSystemList" (scrollToEnd)="fetchMoreControlSystem()" [virtualScroll]='true'
                [closeOnSelect]="false" [searchable]="true"
                #controlSystem="ngModel" name="controlSystem" [attr.data-field]="'controlSystem'" [attr.data-multi]="'true'"
                placeholder="{{ 'Select Control System' | translate}}" (ngModelChange)="onFormChange()">
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  <input id="control-system-item-{{index}}" type="checkbox" [ngModelOptions]="{standalone: true}" [ngModel]="item$.selected" />
                  {{item.controlSystem}}
                </ng-template>
              </ng-select>
              <ion-text class="validate-error"
                *ngIf="!formData.controlSystem || formData.controlSystem.length === 0">
                {{ 'required' | translate }}
              </ion-text>
            </div>
          </ion-col>
          <ion-col size="6">
            <div class="machine-each-div">
              <ion-label> {{ 'Specific Feature' | translate}} *</ion-label>
              <ng-select class="cust-name-select" [multiple]="true" [selectableGroup]="true" required [clearable]="true" bindLabel="specificFeature" bindValue="id"
                [(ngModel)]="formData.features" [items]="featureList"
                (scrollToEnd)="fetchMoreFeature()" [virtualScroll]='true'
                [closeOnSelect]="false" [searchable]="true"
                #specificFeature="ngModel"
                name="specificFeature" [attr.data-field]="'features'" [attr.data-multi]="'true'"
                placeholder="{{ 'Select Features' | translate}}" (ngModelChange)="onFormChange()">
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  <input id="feature-item-{{index}}" type="checkbox" [ngModelOptions]="{standalone: true}" [ngModel]="item$.selected" />
                  {{item.specificFeature}}
                </ng-template>
              </ng-select>
              <ion-text class="validate-error"
                *ngIf="!formData.features || formData.features.length === 0">
                {{ 'required' | translate }}
              </ion-text>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="6">
            <div class="machine-each-div">
              <ion-label> {{ 'Manufacturer' | translate }} </ion-label>
              <ion-item lines=none>
                <ion-input  name="manufacturer"
                  placeholder="{{ 'Enter Manufacturer' | translate }}"
                  [(ngModel)]="formData.manufacturer" #manufacturer="ngModel"
                  (ngModelChange)="onOptionalTextFieldChange('manufacturer', $event)">
                </ion-input>
              </ion-item>
            </div>
          </ion-col>
          <ion-col size="6">
            <div class="machine-each-div">
              <ion-label> {{ 'Model Number' | translate }} </ion-label>
              <ion-item lines=none>
                <ion-input name="machine_Model" [(ngModel)]="formData.machine_Model"
                  placeholder="{{ 'Enter Model' | translate }}" name="machine_Model"
                  #machine_Model="ngModel" (ngModelChange)="onOptionalTextFieldChange('machine_Model', $event)">
                </ion-input>
              </ion-item>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="6">
            <div class="machine-each-div">
              <ion-label> {{ 'Serial Number' | translate }} </ion-label>
              <ion-item lines=none>
                <ion-input name="serial_Number"
                  placeholder="{{ 'Enter Serial Number' | translate }}"
                  [(ngModel)]="formData.serial_Number" #serial_Number="ngModel"
                  (ngModelChange)="onOptionalTextFieldChange('serial_Number', $event)">
                </ion-input>
              </ion-item>
            </div>
          </ion-col>
          <ion-col size="6">
            <div class="machine-each-div">
              <ion-label> {{ 'Asset Number' | translate }} </ion-label>
              <ion-item lines=none>
                <ion-input name="asset_Number"
                  placeholder="{{ 'Enter Asset Number' | translate }}"
                  [(ngModel)]="formData.asset_Number" #asset_Number="ngModel"
                  (ngModelChange)="onOptionalTextFieldChange('asset_Number', $event)">
                </ion-input>
              </ion-item>
            </div>
          </ion-col>
      </ion-row>
      </ion-grid>
    </form>
    <ng-container *ngIf="!isEditAttributes">
      <ion-grid class="machine-attribute-view-container machine-form-scroll scrollVertical">
        <ion-row>
          <ion-col size="6">
            <ion-label class="label-title">{{ 'Machine Type' | translate }} *</ion-label>
            <ion-label class="label-value">{{ selectedMachineType || ('not_available' | translate) }}</ion-label>
          </ion-col>
          <ion-col size="6">
            <ion-label class="label-title">{{ 'Application' | translate }} *</ion-label>
            <ion-label class="label-value">{{ selectedApplication || ('not_available' | translate) }}</ion-label>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="6">
            <ion-label class="label-title">{{ 'Control System' | translate }} *</ion-label>
            <ion-label class="label-value">{{ selectedControlSystem || ('not_available' | translate)}}</ion-label>
          </ion-col>
          <ion-col size="6">
            <ion-label class="label-title">{{ 'Specific Feature' | translate }} *</ion-label>
            <ion-label class="label-value">{{ selectedFeatures || ('not_available' | translate)}}</ion-label>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="6">
            <ion-label class="label-title">{{ 'Manufacturer' | translate }}</ion-label>
            <ion-label class="label-value">{{ formData?.manufacturer }}</ion-label>
          </ion-col>
          <ion-col size="6">
            <ion-label class="label-title">{{ 'Model Number' | translate }}</ion-label>
            <ion-label class="label-value">{{ formData?.machine_Model }}</ion-label>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="6">
            <ion-label class="label-title">{{ 'Serial Number' | translate }}</ion-label>
            <ion-label class="label-value">{{ formData?.serial_Number }}</ion-label>
          </ion-col>
          <ion-col size="6">
            <ion-label class="label-title">{{ 'Asset Number' | translate }}</ion-label>
            <ion-label class="label-value">{{ formData?.asset_Number }}</ion-label>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ng-container>
  </ion-grid>
</ion-row>